<template>
  <div class="big quickInquiryList">
    <div class="page_title">极速问诊订单</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="search-box">
          <!-- 患者姓名 -->
          <div class="item">
            <span style="width: 70px">患者姓名</span>
            <div class="item-content">
              <el-input
                v-model="searchForm.real_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="患者姓名"
              ></el-input>
            </div>
          </div>

          <!-- 接诊医生姓名 -->
          <div class="item">
            <span style="width: 100px">接诊医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="searchForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="接诊医生姓名"
              ></el-input>
            </div>
          </div>

          <!-- 问诊时间 -->
          <div class="item">
            <span style="width: 70px">问诊时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="searchForm.create_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 接诊时间 -->
          <div class="item">
            <span style="width: 70px">接诊时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="searchForm.agree_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 状态 -->
          <div class="item">
            <span style="width: 70px">状态</span>
            <div class="item-content">
              <el-select
                v-model="searchForm.status"
                placeholder="请选择"
                clearable
                size="small"
                @change="getList"
              >
                <el-option
                  v-for="(item, index) in statusOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
              <el-button
                type="primary"
                size="small"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1752') : false
                "
                @click="excelexport"
                >导出</el-button
              >
            </div>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'user_info'">
                  <span>{{ scope.row.real_name }}&nbsp;&nbsp;</span>
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-if="scope.row.sex == 2">女</span>
                  <span v-if="!scope.row.sex">未知</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>

                <div v-else-if="item.prop == 'pay_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'doctor_info'">
                  <div>
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>
                    {{ scope.row.doc_phone }}
                  </div>
                </div>

                <div v-else-if="item.prop == 'pay_money'">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      问诊费用:&nbsp;{{ scope.row.consult_money }}元<br />
                      优惠券:&nbsp;-{{ scope.row.coupon_money }}元<br />
                      礼品卡:&nbsp;-{{ scope.row.gift_money }}元<br />
                      合计:&nbsp;{{ scope.row.pay_money }}元<br />
                    </div>
                    <span>{{ scope.row.pay_money }}</span>
                  </el-tooltip>
                </div>

                <div v-else-if="item.prop == 'doctor_name_string'">
                  <el-link
                    @click="doctorNameListBtn(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1755')
                        : false
                    "
                    style="cursor: pointer"
                  >
                    {{ scope.row[item.prop] }}
                  </el-link>
                </div>

                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>

                <div v-else-if="item.prop == 'agree_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null" ||
                    scope.row[item.prop] == ""
                      ? "---"
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 匹配医生信息 -->
    <el-dialog
      title="匹配医生信息"
      :visible.sync="dialogTableVisible"
      width="600px"
    >
      <div style="padding: 20px">
        <el-table :data="gridData" border>
          <el-table-column
            property="doctor_name"
            label="医生姓名"
            width="120"
          ></el-table-column>
          <el-table-column
            property="phone"
            label="医生手机号"
            width="120"
          ></el-table-column>
          <el-table-column property="hospital" label="医院"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        real_name: "",
        doctor_name: "",
        status: "",
        create_start_time: [],
        agree_time: [],
      },
      statusOptions: [
        {
          label: "未支付",
          value: 0,
        },
        {
          label: "待接诊",
          value: 1,
        },
        {
          label: "已接诊",
          value: 2,
        },
        {
          label: "超时未接诊",
          value: 3,
        },
      ],
      tableHeader: [
        {
          label: "患者信息",
          prop: "user_info",
          width: "180",
          align: "center",
          fixed: "left",
        },
        {
          label: "用户手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "支付时间",
          prop: "pay_time",
          width: "160",
          align: "center",
          fixed: false,
        },

        {
          label: "问诊费用",
          prop: "consult_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "实付金额",
          prop: "pay_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "所选科室",
          prop: "department_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "自述信息",
          prop: "desc",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "匹配疾病",
          prop: "keywords_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "匹配医生",
          prop: "doctor_name_string",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "接诊医生信息",
          prop: "doctor_info",
          width: "160",
          align: "center",
          fixed: "right",
        },
        {
          label: "接诊时间",
          prop: "agree_time",
          width: "160",
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      dialogTableVisible: false,
      gridData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },

    statusText(val) {
      switch (val) {
        case 0:
          return "未支付";
        case 1:
          return "待接诊";
        case 2:
          return "已接诊";
        case 3:
          return "超时未接诊";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.searchForm);
      params = _.omit(params, ["create_time"]);
      let create_time = this.searchForm.create_time;
      let agree_time = this.searchForm.agree_time;
      params["create_time_start"] = create_time ? create_time[0] : "";
      params["create_time_end"] = create_time ? create_time[1] : "";
      params["agree_start_time"] = agree_time ? agree_time[0] : "";
      params["agree_start_end"] = agree_time ? agree_time[1] : "";

      this.tableLoading = true;
      marketing.getUserConsultFastList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    doctorNameListBtn(row) {
      let { doctor_name_list } = row;
      this.gridData = doctor_name_list;
      this.dialogTableVisible = true;
    },
    // 导出
    excelexport() {
      let params = Object.assign(this.pagination, this.searchForm);
      params = _.omit(params, ["create_time"]);
      let create_time = this.searchForm.create_time;
      let agree_time = this.searchForm.agree_time;
      params["create_time_start"] = create_time ? create_time[0] : "";
      params["create_time_end"] = create_time ? create_time[1] : "";
      params["agree_start_time"] = agree_time ? agree_time[0] : "";
      params["agree_start_end"] = agree_time ? agree_time[1] : "";
      const loading = this.$loading();
      marketing
        .exportUserConsultFastList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.quickInquiryList {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
